import { ContentCopy, Done } from "@mui/icons-material";
import { IconButton, SxProps, Tooltip, Theme } from "@mui/material";
import useCopy from "helpers/hooks/useCopy";
import { ReactNode } from "react";

const CopyToClipboard = ({
  text,
  sx,
  title,
  copyIcon,
  disabled,
}: {
  text: string | (() => string);
  title?: string;
  sx?: SxProps<Theme>;
  copyIcon?: ReactNode;
  disabled?: boolean;
}) => {
  const [isCopied, copy] = useCopy();

  return (
    <Tooltip arrow title={isCopied ? "Copied!" : title || "Copy to Clipboard"} placement="top">
      <span>
        <IconButton
          disabled={disabled}
          onClick={() => {
            typeof text === "string" ? copy(text) : copy(text());
          }}
          sx={{ ml: 1, ...sx }}
          color="default"
          size="small">
          {isCopied ? <Done sx={sx} /> : copyIcon || <ContentCopy sx={sx} />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default CopyToClipboard;
